module.exports = __webpack_public_path__ + "img/vertical_6_6_7005.01440ba7.png";